import { modes } from "../modes";
import { permissions } from "../permissions/permissions";

export const formPermissionProfiles = {
    CREATE_FORMS: {
        //[modes.EDIT]: [roles.OWNER],
        [modes.EDIT_PERMISSION]: [permissions.FORMS.CREATE],
    }
}